import ApiPagingRequestModelBase from '../_generated/modelBases/api-paging-request-model-base';

export default class ApiPagingRequestModel extends ApiPagingRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
